<template></template>

<script>
export default {
  name: "Logout",
  data() {
    return {};
  },
  mounted() {
    if (localStorage.getItem("token")) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      this.$http.defaults.headers.common["Authorization"] = null;
    }

    this.$router.push('/')

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/Logout.vue